export interface RequiredConfig {
  sdkKey: string;
}

export interface OptionalConfig {
  /**
   * @deprecated
   */
  API_KEY: string;
  host: string;
  api: string;
  maxRetries: number;
  debugMode: boolean;
}

export type Config = RequiredConfig & Partial<OptionalConfig>;

const defaultOptions: Config = {
  sdkKey: "",
  api: "https://api.spindl.xyz/v1",
  host: "https://spindl.link",
  maxRetries: 3,
  debugMode: false,
};

export type ConfigPlugin = ReturnType<typeof createConfigPlugin>;

export function createConfigPlugin(initialConfig: Config) {
  let _config = {
    ...defaultOptions,
    ...initialConfig,
    // remove the fallback for API_KEY in next minor release
    sdkKey:
      initialConfig.sdkKey ?? initialConfig.API_KEY ?? defaultOptions.sdkKey,
  };

  function setConfig(updates: Partial<Config>) {
    // remove the fallback for API_KEY in next minor release
    const sdkKey = updates.API_KEY ?? updates.sdkKey ?? _config.sdkKey;
    _config = { ..._config, ...updates, sdkKey };
  }

  function getConfig() {
    return _config;
  }

  return {
    setConfig,
    getConfig,
  };
}
